export const MenuIcon = () =>
    <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"
         width="24.000000" height="24.000000" fill="none">
        <rect id="24 / Navigation / Menu" width="24.000000" height="24.000000" x="0.000000" y="0.000000"/>
        <path id="Union"
              d="M22 5.25L2 5.25L2 6.75L22 6.75L22 5.25ZM2 11.25L22 11.25L22 12.75L2 12.75L2 11.25ZM2 17.25L22 17.25L22 18.75L2 18.75L2 17.25Z"
              fill="rgb(88,93,105)" fillRule="evenodd"/>
    </svg>

